<template lang="pug">
  v-row(no-gutters)
    v-col(xs12 sm6 md4 lg4 xl2)
      v-row(no-gutters)
        v-col(cols='12')
          strong Plan Eligibility:
      .box
        v-row(no-gutters)
          v-col(cols='12')
            v-icon.pr-2(small color='gray') mdi-file-tree
            strong Limits
        v-row(wrap no-gutters)
          v-col(cols='12')
            v-row(no-gutters)
              v-col(xs6)
                v-icon.pr-2(small color='green') mdi-chart-bar
                | Max Restaurants:
              v-col(xs6)
                code {{myFeatures.eligibleCounts.R}}
                | /group
          v-col(cols='12')
            v-row(no-gutters)
              v-col(xs6)
                v-icon.pr-2(small color='green') mdi-chart-bar
                | Max Sections:
              v-col(xs6)
                code {{myFeatures.eligibleCounts.S}}
                | /restaurant
          v-col(cols='12')
            v-row(no-gutters)
              v-col(xs6)
                v-icon.pr-2(small color='green') mdi-chart-bar
                | Max Counters:
              v-col(xs6)
                code {{myFeatures.eligibleCounts.C}}
                | /restaurant
          v-col(cols='12')
            v-row(no-gutters)
              v-col(xs6)
                v-icon.pr-2(small color='green') mdi-chart-bar
                | Max Users:
              v-col(xs6)
                code {{myFeatures.eligibleCounts.U}}
                | /group
          v-col(cols='12')
            v-row(no-gutters)
              v-col(xs6)
                v-icon.pr-2(small color='green') mdi-chart-bar
                | Max Products:
              v-col(xs6)
                code {{myFeatures.eligibleCounts.P}}
                | /restaurant
          v-col(cols='12')
            v-row(no-gutters)
              v-col(xs6)
                v-icon.pr-2(small color='green') mdi-chart-bar
                | Max Orders:
              v-col(xs6)
                code.pl-2 {{myFeatures.eligibleCounts.O}}
                | /month/group
          v-col(cols='12')
            v-row(no-gutters)
              v-col(xs6)
                v-icon.pr-2(small color='green') mdi-chart-bar
                | Max Backups Age:
              v-col(xs6)
                code.pl-2 {{myFeatures.eligibleCounts.B}}
                | days
        v-row(no-gutters)
          v-col(cols='12')
            v-icon.pr-2(small) mdi-playlist-play
            strong Features
        v-row(wrap no-gutters)
          v-col(cols='6' v-for='feature in Object.keys(features)' :key='feature')
            v-icon.pr-2(small v-if='myFeatures.eligibleFeatures.includes(feature)' color='green') mdi-check
            v-icon.pr-2(small v-else color='red') mdi-close
            |             {{feature}}
            v-tooltip(top)
              template(v-slot:activator='{ on }')
                v-icon(small color='light' v-on='on') mdi-help
              span {{features[feature]}}

</template>
<script>
import { storeMixin } from "../../mixins/storeMixin.js";
export default {
  name: "my-features",
  data() {
    return {
      features: {
        REPORT: "Open/Closeout available to the sections and counters.",
        TIMER: "Time tracking will be avaiable on the services and orders.",
        BILLSPLIT: "Will be able to choose and split the bills upto 9 bills.",
        INCENTIVE:
          "Incentives can be set on products and reports will calculate totals",
        WORKFLOW: "Allows tracking the orders at multiple levels",
        VOICE:
          "Voice enabled search and announcement of the orders will be available",
        INVENTORY:
          "Product inventory can be set and as the orders are served, the count gets decremented",
        TAX:
          "Tax can be configured on products subsequently calculations will flow into bills and reports"
      }
    };
  },
  mixins: [storeMixin]
};
</script>
<style>
.box {
  border-style: solid;
  border-width: 1px;
  border-color: lightgray;
}
</style>